import { makeStyles } from '@material-ui/core/styles'
import { theme } from 'config/constants/theme/theme'

export const useStyles = makeStyles({
  root: {
    height: '100%'
  },
  content: {
    position: 'relative',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  contentGrid: {
    paddingTop: 70,
    paddingBottom: 70,
    [theme.breakpoints.down('md')]: {
      padding: 10
    }
  },
  h3: {
    color: '#FDB72A',
    fontSize: 35,
    fontWeight: 300,
    margin: 'auto'
  },
  logoContainer: {
    height: 55,
    width: '100vw'
  },
  pageSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: 'white',
    position: 'relative',
    paddingBottom: '30px',
    '&:last-child': {
      borderRadius: '0 0 12px 12px',
      minHeight: 'auto',
      paddingBottom: 0
    },
    '&:first-child': {
      borderRadius: '12px 12px 0 0'
    }
  },
  resetPaddingBottom: {
    marginBottom: '-30px'
  }
})
